import React from 'react';
import { PlusIcon, CheckIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ChiffrageVersion } from '../types/Version';

interface VersionTabsProps {
  versions: ChiffrageVersion[];
  activeVersionId: string;
  onSelectVersion: (id: string) => void;
  onDuplicateVersion: () => void;
}

const VersionTabs: React.FC<VersionTabsProps> = ({
  versions,
  activeVersionId,
  onSelectVersion,
  onDuplicateVersion,
}) => {
  return (
    <div className="flex items-center gap-1">
      {versions.map((version) => {
        const isActive = version.id === activeVersionId;
        const isDraftOld = version.status === 'draft-old';
        const isFinalized = version.status === 'finalized';

        let pillClass = '';
        if (isActive) {
          if (isDraftOld) {
            pillClass = 'bg-white border border-orange-400 text-orange-600 shadow-sm';
          } else if (isFinalized) {
            pillClass = 'bg-white border border-gray-300 text-gray-500 shadow-sm';
          } else {
            pillClass = 'bg-white border border-violet-300 text-violet-700 shadow-sm';
          }
        } else {
          if (isDraftOld) {
            pillClass = 'text-orange-400 hover:text-orange-600 hover:bg-orange-50';
          } else if (isFinalized) {
            pillClass = 'text-gray-400 hover:text-gray-600 hover:bg-gray-100';
          } else {
            pillClass = 'text-gray-400 hover:text-gray-600 hover:bg-gray-100';
          }
        }

        return (
          <button
            key={version.id}
            type="button"
            onClick={() => onSelectVersion(version.id)}
            className={`flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium transition-all select-none ${pillClass}`}
          >
            {isDraftOld && <ExclamationTriangleIcon className="w-3 h-3" />}
            {isFinalized && <CheckIcon className="w-3 h-3" />}
            {version.name}
          </button>
        );
      })}

      <button
        type="button"
        onClick={onDuplicateVersion}
        title="Créer une nouvelle version"
        className="w-5 h-5 flex items-center justify-center rounded text-gray-300 hover:text-gray-500 hover:bg-gray-100 transition-all"
      >
        <PlusIcon className="w-3 h-3" />
      </button>
    </div>
  );
};

export default VersionTabs;
